import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { ObjectType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
// need to import this immediately because it's above the fold and could cause CLS
import ListOffer from '@/features/buybox/components/list/ListOffer.vue';

import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { computed, provide } from 'vue';
import { useExperiment } from '@/libraries/experiment';
import { useJWTVCampaign } from '@/features/jwtv-titles-rental/composables/useJWTVCampaign';
import { useSRFilminCampaign } from '@/helpers/composables/useSRFilminCampaign';
import { getBoneTempleRentOffer } from '@/features/promotions/helpers/boneTemplePromotedCampaign';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedListBuyBox',
  props: {
    promotedOffers: null,
    objectType: null,
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	promotedOffers: BuyboxRegularOffer[];
	objectType: ObjectType;
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};

const languageStore = useLanguageStore();

const { activeVariantWithControlGroup: buyRentExpVariant } = useExperiment('EXP_MERGE_BUY_RENT');



const { tc } = useI18n();
useProvideClickoutPlacement('promoted_buybox');

provide('offerLocation', OfferLocation.PROMOTED_BUYBOX);

const { getPromotedOffersWithJwtv } = useJWTVCampaign();
// FILMIN SR CAMPAIGN
const { getCampaignPromotedOffers, isTitleCampaignEligible } = useSRFilminCampaign({
	titleId: props.title.id,
	promotedOffers: props.promotedOffers,
	flatrateOffers: props.title.flatrate ?? [],
});

// BONE TEMPLE SR CAMPAIGN
const boneTempleOffer = computed(() => getBoneTempleRentOffer(languageStore.country, props.title.id));

const allPromotedOffers = computed(() => {
	if (!!isTitleCampaignEligible.value) {
		return getCampaignPromotedOffers();
	}

	const normalOffers = getPromotedOffersWithJwtv(props.promotedOffers, props.title);

	if (boneTempleOffer.value != null) {
		return [...normalOffers, boneTempleOffer.value];
	}

	return normalOffers;
});

return { __sfc: true,languageStore, buyRentExpVariant, props, tc, getPromotedOffersWithJwtv, getCampaignPromotedOffers, isTitleCampaignEligible, boneTempleOffer, allPromotedOffers, ListOffer }
}

})